'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgCardView(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("path", { d: "M2 3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V6C14 6.55228 13.5523 7 13 7H3C2.44772 7 2 6.55228 2 6V3Z", fill: "#031B4A" }),
        React__default.default.createElement("path", { d: "M2 10C2 9.44772 2.44772 9 3 9H13C13.5523 9 14 9.44772 14 10V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V10Z", fill: "#031B4A" })));
}

module.exports = SvgCardView;
//# sourceMappingURL=CardView.js.map
